import script from "./BaseCheckbox.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseCheckbox.vue?vue&type=script&lang=ts&setup=true"

import "./BaseCheckbox.vue?vue&type=style&index=0&id=b2b85858&lang=scss"

const __exports__ = script;

export default __exports__